const Error=()=>{
    return (
        <>
        <div className="errors">
            <h2>Something get wrong </h2>
            <p>We're unable to retrieve the weather details. Ensure you've entered a valid city or try again.</p>
        </div>
        </>
    )
}
export default Error;